export const LEGEND_SECTIONS = [
  {
    id: "soilMoisture",
    show: "showSoilMoisture",
    section: null,
    type: "gradient", // type: "gradient" | "color" | "line" | "point" | "icon"
    label: "Valeur d'humidité de sol (%)",
    ticks: [">0", 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    gradient: `linear-gradient(to right,
      rgba(210,180,140,0) 0%, rgb(210,180,140) 10%, rgb(160,190,170) 20%,
      rgb(100,200,200) 30%, rgb(80,180,220) 40%, rgb(50,150,240) 50%,
      rgb(30,120,230) 60%, rgb(20,100,200) 70%, rgb(15,80,180) 80%,
      rgb(10,60,150) 90%, rgb(5,40,120) 100%)`,
  },
  {
    id: "windSpeed",
    show: "showWindSpeedData",
    section: null,
    type: "gradient",
    label: "Vent à une hauteur de 10 m (km/h)",
    ticks: [0, 7, 18, 36, 54, 72, 90, 108, 126, 144, "+160"],
    gradient: `linear-gradient(to right,
      rgba(255,255,255,0.8) 0%, rgba(186,85,211,0.6) 10%, rgb(75,0,130) 20%,
      rgb(255,140,0) 30%, rgb(255,165,0) 40%, rgb(255,215,0) 50%,
      rgb(255,69,0) 60%, rgb(255,0,0) 70%, rgb(139,0,0) 80%,
      rgb(255,20,147) 90%, rgb(139,0,255) 100%)`,
  },
  {
    id: "cloudCover",
    show: "showCloudCover",
    section: null,
    type: "gradient",
    label: "Couverture nuageuse (%)",
    ticks: [5, 20, 40, 60, 80, 100],
    gradient: `linear-gradient(to right,
      rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 20%,
      rgba(255,255,255,0.4) 40%, rgba(255,255,255,0.6) 60%,
      rgba(255,255,255,0.8) 80%, rgba(255,255,255,1.0) 100%)`,
  },
  {
    id: "precipitations",
    show: "showPrecipitations",
    section: null,
    type: "gradient",
    label: "Précipitation totale (mm)",
    ticks: [0.25, 2, 5, 10, 20, 40, 70, 100, 500, 1000],
    gradient: `linear-gradient(to right,
      rgba(253,198,206,0.7) 0%, rgba(241,15,91,0.7) 10%, rgba(186,85,211,0.7) 20%,
      rgb(40,207,219) 30%, rgb(15,126,190) 40%, rgb(172,6,172) 50%,
      rgb(133,6,165) 60%, rgba(195,0,255,0.45) 70%, rgb(18,101,150) 80%,
      rgb(16,74,184) 100%)`,
  },
  {
    id: "hourlyPrecipitations",
    show: "showHourlyPrecipitations",
    section: null,
    type: "gradient",
    label: "Précipitation horaires cumulées (mm)",
    ticks: [0.25, 2, 5, 10, 20, 40, 70, 100, 500, 1000],
    gradient: `linear-gradient(to right,
      rgba(224,243,255,0.7) 0%, rgba(168,221,255,0.7) 10%, rgba(100,191,255,0.7) 20%,
      rgba(51,153,255,0.7) 30%, rgba(0,102,204,0.7) 40%, rgba(0,51,153,0.7) 50%,
      rgba(102,0,153,0.7) 60%, rgba(153,0,153,0.7) 70%, rgba(204,0,102,0.7) 80%,
      rgba(255,0,0,0.7) 100%)`,
  },
  {
    id: "temperature",
    show: "showTemperature",
    section: null,
    type: "gradient",
    label: "Température (°C)",
    ticks: [-20, -10, 0, 10, 20, 25, 30, 40, 45, 50],
    gradient: `linear-gradient(to right,
      rgba(0,0,139,0.7) 0%, rgba(9,13,238,0.7) 10%, rgba(7,152,248,0.7) 20%,
      rgba(13,225,233,0.7) 30%, rgba(173,216,230,0.7) 40%, rgba(255,215,0,0.7) 50%,
      rgba(245,141,23,0.93) 60%, rgba(252,115,2,0.94) 70%, rgba(255,69,0,0.7) 80%,
      rgba(128,0,0,0.7) 100%)`,
  },
  {
    id: "relativeHumidity",
    show: "showRelativeHumidity",
    section: null,
    type: "gradient",
    label: "Humidité relative (%)",
    ticks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    gradient: `linear-gradient(to right,
      rgba(255,255,224,0.7) 0%, rgba(255,239,163,0.7) 10%, rgba(250,211,55,0.7) 20%,
      rgba(152,251,152,0.7) 30%, rgba(99,233,99,0.7) 40%, rgba(0,255,128,0.93) 50%,
      rgba(0,255,255,0.7) 60%, rgba(118,179,230,0.7) 70%, rgba(38,112,248,0.7) 80%,
      rgba(34,34,247,0.7) 90%, rgba(0,0,139,0.7) 100%)`,
  },
  {
    id: "pressure",
    show: "showMeanSeaLevelPressure",
    section: null,
    type: "gradient",
    label: "Pression au niveau de la mer (Pa)",
    ticks: ["90K", "100K", "102K", "105K", "107K", "110K"],
    gradient: `linear-gradient(to right,
      rgba(145,130,255,0.7) 0%, rgba(245,18,75,0.7) 20%, rgba(71,41,240,0.7) 40%,
      rgba(22,2,87,0.7) 60%, rgba(168,58,73,0.7) 80%, rgba(139,0,0,0.7) 100%)`,
  },
  {
    id: "windGust",
    show: "showWindGust",
    section: null,
    type: "gradient",
    label: "Vitesse des rafales de vent (km/h)",
    ticks: [0, 18, 36, 54, 72, 90, "+100"],
    gradient: `linear-gradient(to right,
      rgba(173,216,230,0.7) 0%, rgba(144,238,144,0.7) 10%, rgba(255,223,0,0.7) 20%,
      rgba(255,165,0,0.7) 40%, rgba(255,69,0,0.7) 60%, rgba(255,0,0,0.7) 80%,
      rgba(139,0,0,0.7) 100%)`,
  },
  {
    id: "dem",
    show: "showDem",
    section: null,
    type: "gradient",
    label: "Modèle numérique du terrain (MNT) (m)",
    ticks: ["<0", 0, 100, 250, 500, 800, 1500, "+1500"],
    gradient: `linear-gradient(to right,
      #140F7C 0%, #2A7FFF 14%, #00E5FF 29%, #58FF6C 43%,
      #FFEA32 57%, #FF8F32 71%, #FF2E00 86%, #FF2E00 100%)`,
  },

  // ─── Limites administratives ──────────────────────────────────────
  {
    id: "regions",
    show: "showRegions",
    section: "Limites administratives",
    type: "line",
    label: "Limites des régions",
    color: "blue",
    popupTitle: "Limites des régions",
    popupText:
      "Représentées par des lignes bleu foncé, elles montrent les frontières des régions.",
  },
  {
    id: "departements",
    show: "showDepartements",
    section: "Limites administratives",
    type: "line",
    label: "Limites des départements",
    color: "rgba(28,252,252,1)",
    popupTitle: "Limites des départements",
    popupText:
      "Représentées par des lignes cyan clair, elles indiquent les délimitations des départements.",
  },

  {
    id: "lai",
    show: "showLai",
    section: "Couches de terrain",
    type: "gradient",
    label: "Indice de surface foliaire",
    ticks: [">0", 1, 2, "3+"],
    gradient: `linear-gradient(to right, #A1D9C1 0%, #73C1AB 33%, rgb(8,82,68) 100%)`,
  },
  {
    id: "deadFuel",
    show: "showDeadFuel",
    section: "Couches de terrain",
    type: "gradient",
    label: "Humidité des combustibles morts (%)",
    ticks: [">0", 10, 20, 30, "+30"],
    gradient: `linear-gradient(to right,
      #800026 0%, #bd0026 4%, #e31a1c 8%, #fc4e2a 12%, #fd8d3c 16%,
      #feb24c 20%, #fed976 24%, #ffffb2 30%, #d9f0a3 36%, #addd8e 44%,
      #78c679 52%, #41ab5d 60%, #238443 75%, #004529 100%)`,
  },
  {
    id: "vegHeight",
    show: "showVegHeight",
    section: "Couches de terrain",
    type: "gradient",
    label: "Hauteur de la végétation (m)",
    ticks: [">0", 3, 10, 20, "20+"],
    gradient: `linear-gradient(to right, #D5B5E5 0%, #A07DC3 33%, rgb(114,69,160) 66%, rgb(53,36,109) 100%)`,
  },
  {
    id: "biomass",
    show: "showBiomass",
    section: "Couches de terrain",
    type: "gradient",
    label: "Biomasse (kg/m²)",
    ticks: [">0", 8, 14, 20, "20+"],
    gradient: `linear-gradient(to right, #F5B46F 0%, #DB804C 33%, rgb(235,98,19) 66%, rgb(119,53,29) 100%)`,
  },
  {
    id: "totalFuelLoad",
    show: "showTotalFuelLoad",
    section: "Couches de terrain",
    type: "gradient",
    label: "Charge combustible totale (kg/m²)",
    ticks: [">0", 1, 2, 3, 4, "4+"],
    gradient: `linear-gradient(to right, #FFEAEA 0%, #FFB3B3 25%, #FF6666 50%, #CC1F1F 75%, #800000 100%)`,
  },
  {
    id: "bareSoil",
    show: "showBareSoil",
    section: "Couches de terrain",
    type: "color",
    label: "Sol nu",
    color: "#D2B48C",
    popupTitle: "Sol nu",
    popupText:
      "Zones marron clair représentant des terres sans végétation ou avec une couverture minimale.",
  },
  {
    id: "broadleaf",
    show: "showBroadleaf",
    section: "Couches de terrain",
    type: "color",
    label: "Forêt de feuillus",
    color: "#65920b",
    popupTitle: "Forêt de feuillus",
    popupText:
      "Forêt composée principalement d'arbres à feuilles caduques comme les chênes, hêtres ou érables.",
  },
  {
    id: "mixedForest",
    show: "showMixedForest",
    section: "Couches de terrain",
    type: "color",
    label: "Forêt mixte",
    color: "#0ceb31",
    popupTitle: "Forêt mixte",
    popupText:
      "Zone forestière mêlant conifères et feuillus, offrant une grande diversité végétale.",
  },
  {
    id: "coniferous",
    show: "showConiferous",
    section: "Couches de terrain",
    type: "color",
    label: "Forêt de conifères",
    color: "#76f5a4",
    popupTitle: "Forêt de conifères",
    popupText:
      "Forêt composée majoritairement d'arbres résineux comme les pins, sapins ou épicéas.",
  },
  {
    id: "shrubland",
    show: "showShrubland",
    section: "Couches de terrain",
    type: "color",
    label: "Strate arbustive",
    color: "#d9d925",
    popupTitle: "Strate arbustive",
    popupText:
      "Zones vert clair représentant des zones dominées par des arbustes ou buissons.",
  },
  {
    id: "cropland",
    show: "showCropland",
    section: "Couches de terrain",
    type: "color",
    label: "Zones agricoles",
    color: "#ebaf0a",
    popupTitle: "Zones agricoles",
    popupText:
      "Zones destinées aux activités agricoles telles que les cultures et l'élevage.",
  },
  {
    id: "grassland",
    show: "showGrassland",
    section: "Couches de terrain",
    type: "color",
    label: "Strate herbacée",
    color: "#9ACD32",
    popupTitle: "Strate herbacée",
    popupText:
      "Zones vert lime représentant des régions principalement couvertes d'herbes et de plantes herbacées.",
  },
  {
    id: "oak",
    show: "showOak",
    section: "Couches de terrain",
    type: "color",
    label: "Chêne",
    color: "#ffb3ee",
    popupTitle: "Chêne",
    popupText:
      "Zone dominée par des chênes, espèce feuillue emblématique des forêts tempérées.",
  },
  {
    id: "pine",
    show: "showPine",
    section: "Couches de terrain",
    type: "color",
    label: "Pin",
    color: "#b69af5",
    popupTitle: "Pin",
    popupText:
      "Zone boisée dominée par des pins, typiques des forêts de conifères.",
  },
  {
    id: "water",
    show: "showWater",
    section: "Ressources en eau",
    type: "icon",
    label: "Points d'eau naturels",
    iconKey: "waterResourcesIcon",
    popupTitle: "Points d'eau naturels",
    popupText:
      "Zones bleues dénotant les lacs, rivières ou autres plans d'eau.",
  },
  {
    id: "artificielWater",
    show: "showArtificielWater",
    section: "Ressources en eau",
    type: "icon",
    label: "Points d'eau artificiels",
    iconKey: "swimmingPoolsIcon",
    popupTitle: "Piscines",
    popupText:
      "Zones représentant des piscines détectées, servant d'indicateurs potentiels de points d'eau résidentiels.",
  },
  {
    id: "dfci",
    show: "showDfci",
    section: "Limites administratives",
    type: "line",
    label: "Grille DFCI",
    color: "#0B03FF",
    dashed: true,
    popupTitle: "Grille DFCI",
    popupText:
      "Représentation des carroyages DFCI (Départemental Fire Control Index) utilisés pour la gestion des feux de forêt. Les codes DFCI permettent d'identifier précisément les zones.",
  },
  {
    id: "urban",
    show: "showUrban",
    section: "Couches de terrain",
    type: "color",
    label: "Zone urbaine",
    color: "#8a8686",
    popupTitle: "Zone urbaine",
    popupText:
      "Zones grises indiquant des régions urbanisées comme les villes ou villages.",
  },

  // ─── buildings in risk ───────────────────────────────────────────
  {
    id: "result1Buildings",
    show: "showResult1Buildings",
    section: "Bâtiments à Risque",
    type: "icon",
    label: "Menace immédiate",
    iconKey: "buildings_t1",
    iconSize: 22,
    popupTitle: "Menace immédiate",
    popupText:
      "Structures situées dans la première zone de propagation prévue, exposées à un danger imminent dans l'heure.",
  },
  {
    id: "result2Buildings",
    show: "showResult2Buildings",
    section: "Bâtiments à Risque",
    type: "icon",
    label: "Menace proche",
    iconKey: "buildings_t2",
    iconSize: 22,
    popupTitle: "Menace proche",
    popupText:
      "Structures localisées dans la deuxième zone de propagation, avec un risque d'impact dans les deux heures.",
  },
  {
    id: "result3Buildings",
    show: "showResult3Buildings",
    section: "Bâtiments à Risque",
    type: "icon",
    label: "Menace modérée",
    iconKey: "buildings_t3",
    iconSize: 22,
    popupTitle: "Menace modérée",
    popupText:
      "Structures exposées à une menace potentielle dans les trois heures suivant la progression prévue du feu.",
  },
  {
    id: "result4Buildings",
    show: "showResult4Buildings",
    section: "Bâtiments à Risque",
    type: "icon",
    label: "Menace plus lointaine",
    iconKey: "buildings_t4",
    iconSize: 22,
    popupTitle: "Menace plus lointaine",
    popupText:
      "Structures susceptibles d'être affectées dans un délai de quatre heures selon les prédictions de propagation.",
  },

  // ─── Points sensibles ─────────────────────────────────────────────
  {
    id: "electricalLinesAerial",
    show: "showElectricalLines",
    section: "Les points sensibles",
    type: "line",
    label: "Lignes electriques",
    color: "#ff0000",
    popupTitle: "Lignes electriques",
    popupText:
      "Représentées par des lignes rouges, elles indiquent l'emplacement des lignes électriques ou de communication suspendues au-dessus du sol.",
  },
  //  {
  //   id: "electricalLinesAerial",
  //   show: "showElectricalLines",
  //   section: "Les points sensibles",
  //   type: "line",
  //   label: "Lignes aériennes",
  //   color: "#ff0000",
  //   popupTitle: "Lignes aériennes",
  //   popupText:
  //     "Représentées par des lignes rouges, elles indiquent l'emplacement des lignes électriques ou de communication suspendues au-dessus du sol.",
  // },
  // {
  //   id: "electricalLinesUnderground",
  //   show: "showElectricalLines",
  //   section: "Les points sensibles",
  //   type: "line",
  //   label: "Lignes sous-terrain",
  //   color: "#8f0707",
  //   popupTitle: "Lignes souterraines",
  //   popupText:
  //     "Dépeintes avec des lignes sombres, elles marquent les chemins des câbles ou pipelines enterrés utilisés pour des services tels que l'électricité, l'eau ou les communications.",
  // },
  // {
  //   id: "electricalPassagePoints",
  //   show: "showElectricalLines",
  //   section: "Les points sensibles",
  //   type: "point",
  //   label: "Points de passage",
  //   color: "#8800ff",
  //   popupTitle: "Points de passage",
  //   popupText:
  //     "Représentés par des points violets, ils indiquent des points clés de croisement ou d'accès, souvent utilisés pour les infrastructures ou les transports.",
  // },
  {
    id: "electricalStations",
    show: "showElectricalStations",
    section: "Les points sensibles",
    type: "color",
    label: "Stations électriques",
    color: "red",
    popupTitle: "Stations électriques",
    popupText:
      "Représentées par des blocs rouges, elles symbolisent l'emplacement des sous-stations électriques ou des centrales électriques essentielles à la distribution d'énergie.",
  },
  {
    id: "electricalTransformers",
    show: "showElectricalStations",
    section: "Les points sensibles",
    type: "point",
    label: "Transformateurs électriques",
    color: "orange",
    popupTitle: "Transformateurs électriques",
    popupText:
      "Modifient la tension du courant pour la transmission et la distribution d'électricité.",
  },
  {
    id: "gazLines",
    show: "showGazLines",
    section: "Les points sensibles",
    type: "line",
    label: "Lignes de gaz",
    color: "#FFD700",
    popupTitle: "Lignes de gaz",
    popupText:
      "Représentent les lignes principales de transport de gaz en France, qui acheminent le gaz sur de longues distances.",
  },
  {
    id: "gazRefuelingStations",
    show: "showGazRefuelingStations",
    section: "Les points sensibles",
    type: "point",
    label: "Stations de ravitaillement en gaz",
    color: "#FFD700",
    popupTitle: "Stations de ravitaillement en gaz",
    popupText:
      "Installations fournissant du gaz naturel comprimé (GNC) ou liquéfié (GNL) pour les véhicules, l'industrie et le chauffage, équipées de réservoirs, compresseurs et distributeurs.",
  },

  // ─── roads ───────────────────────────────────────────────────────
  {
    id: "majorRoads",
    show: "showMajorRoads",
    section: "Les routes",
    type: "road",
    label: "Routes principales",
    thickness: 5,
    color: "black",
    popupTitle: "Routes principales",
    popupText:
      "Les routes les plus importantes pour les déplacements longue distance et à grande capacité (autoroutes, routes principales, routes primaires).",
  },
  {
    id: "secondaryRoads",
    show: "showMajorRoads",
    section: "Les routes",
    type: "road",
    label: "Routes secondaires",
    thickness: 4,
    color: "black",
    minZoom: 10,
    popupTitle: "Routes secondaires",
    popupText:
      "Les routes secondaires reliant les villes et les routes tertiaires connectant les petites villes et villages.",
  },
  {
    id: "residentialRoads",
    show: "showMajorRoads",
    section: "Les routes",
    type: "road",
    label: "Voiries résidentielles",
    thickness: 3,
    color: "black",
    minZoom: 13,
    popupTitle: "Voiries résidentielles",
    popupText:
      "Les rues locales situées dans les zones résidentielles, desservant les quartiers et parfois les commerces de proximité.",
  },
  {
    id: "accessPaths",
    show: "showMajorRoads",
    section: "Les routes",
    type: "road",
    label: "Chemins d'accès",
    thickness: 2,
    color: "black",
    minZoom: 13,
    popupTitle: "Chemins d'accès",
    popupText:
      "Des voies étroites destinées aux piétons et aux cyclistes, souvent situées dans des zones résidentielles, des parcs ou des environnements ruraux.",
  },
  {
    id: "railways",
    show: "showRailways",
    section: "Les routes",
    type: "line",
    label: "Chemins de fer",
    color: "#503B3B",
    popupTitle: "Chemins de fer",
    popupText:
      "Représentent les principales voies ferrées en France, utilisées pour le transport.",
  },
  {
    id: "trainStations",
    show: "showRailways",
    section: "Les routes",
    type: "point",
    label: "Stations de train",
    color: "#503B3B",
  },

  // ─── Security ───────────────────────────────────────────
  {
    id: "fireStations",
    show: "showFireStations",
    section: "Installations de sécurité et d'urgence",
    type: "icon",
    label: "Centres d'incendie et de secours",
    iconKey: "fireDepartementIcon",
    iconSize: 16,
    popupTitle: "Centres d'incendie et de secours",
    popupText:
      "Visualiser la localisation des stations de secours et la distribution des ressources.",
  },
  //------------------active fires-------------
   {
    id: "activeFires",
    show: "showActiveFires",
    section: "Points chauds",
    type: "icon",
    label: "Points chauds",
    iconKey: "activeFire",
    iconSize: 22,
    popupTitle: "Points chauds (feux actifs)",
    popupText:
"Localisation des départs de feu actuellement détectés par satellite. (EUMETSAT LSA SAF [MTG FRP-Pixel, LSA-509])"  },
  {
    id: "historicFiresArea",
    show: "showHistoricFires",
    section: null,
    type: "color",
    label: "Zone brûlée (feu historique)",
    color: "rgba(255,0,0,0.55)",
    popupTitle: "Zone brûlée",
    popupText:
      "Surface parcourue par un feu historique sélectionné.",
  },
  {
    id: "historicFiresIcon",
    show: "showHistoricFires",
    section: null,
    type: "icon",
    label: "Feu historique sélectionné",
    iconKey: "historicFire",
    iconSize: 20,
    popupTitle: "Feu historique",
    popupText:
      "Point représentatif de la localisation d'un feu historique sélectionné et affiché sur la carte.",
  },
];
